/** Company POS policies from the access config every signed-in user receives. */
let blindShiftClose = true;
let idleLockMinutes = 5;
let varianceNoteThreshold = 500;

const nonNegative = (value: unknown, fallback: number) =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : fallback;

export function setPosPolicy(config: {
  posBlindShiftClose?: boolean;
  posIdleLockMinutes?: number;
  posVarianceNoteThreshold?: number;
}): void {
  blindShiftClose = config.posBlindShiftClose !== false;
  idleLockMinutes = nonNegative(config.posIdleLockMinutes, 5);
  varianceNoteThreshold = nonNegative(config.posVarianceNoteThreshold, 500);
}

export function isPosBlindShiftClose(): boolean {
  return blindShiftClose;
}

/** 0 means the terminal never locks on its own. */
export function getPosIdleLockMinutes(): number {
  return idleLockMinutes;
}

/** 0 means a closing note is never required. */
export function getPosVarianceNoteThreshold(): number {
  return varianceNoteThreshold;
}
